import { showErrorToast } from "@/utils/showToast";
import ReCAPTCHA from "react-google-recaptcha";
import { toast } from "react-toastify";

export const Captcha = ({
  lang,
  setRecaptchaToken,
}: {
  lang: string;
  setRecaptchaToken: (token: string | null) => void;
}) => {
  return (
    <ReCAPTCHA
      onChange={(token: string | null) => setRecaptchaToken(token)}
      sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY!}
      onErrored={() => toast.error("Captcha failed to load. Please refresh.")}
      onExpired={() => {
        setRecaptchaToken(null);
        showErrorToast("Captcha expired. Please try again.");
      }}
      hl={lang}
    />
  );
};
